export const Constants = {
    ITEMS_UPDATE_INTERVAL: (process.env.REACT_APP_ITEMS_UPDATE_INTERVAL) || 60000
}


// WEBPACK FOOTER //
// ./src/model/constants/constants.js